import { baseApi } from "./baseApi";

const loanDocumentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLoanDocuments: builder.query({
      query: (loanId) => ({
        url: `/loans/${loanId}/documents`,
        method: "GET",
      }),
      providesTags: (result, error, loanId) => [
        { type: "LoanDocuments", id: loanId },
      ],
    }),
    uploadLoanDocument: builder.mutation({
      query: ({ loanId, formData }) => ({
        url: `/loans/${loanId}/documents`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "LoanDocuments", id: loanId },
      ],
    }),
    reuploadLoanDocument: builder.mutation({
      query: ({ loanId, documentId, formData }) => ({
        url: `/loans/${loanId}/documents/${documentId}/reupload`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "LoanDocuments", id: loanId },
      ],
    }),
  }),
});

export default loanDocumentsApi;
